import { Navbar, Container, Nav, Button, Offcanvas } from "react-bootstrap";
import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { NavHashLink, HashLink } from "react-router-hash-link";
import logo from "./../assets/logomark.svg";
import zerkotype from "./../assets/zerkotype.svg";
import star from "./../assets/rounded_star.svg";
import { CgMenuRight } from "react-icons/cg";
import {
  FaTwitter,
  FaInstagram,
  FaYoutube,
  FaDiscord,
  FaTiktok,
} from "react-icons/fa";
import { AiOutlineClose } from "react-icons/ai";
import { CSSTransition } from "react-transition-group";
function MyNavbar() {
  const [show, setShow] = useState(false);
  const handleClose = () => {
    setShow(false);
  };
  const handleShow = () => {
    setShow("block"); // same as transition time
  };
  return (
    <>
      <header className="navbar-expand-lg sticky-top bg-brand shadow-v1 py-12px">
        <Container className="d-flex justify-content-center  p-0 ">
          <NavHashLink to="/" className="text-decoration-none mx-3">
            <Navbar.Brand>
              <img width="28" src={logo} alt="logo of zerko" />
              {"  "}

              <img width="89" src={zerkotype} alt="zerko text" />
            </Navbar.Brand>
          </NavHashLink>
          <Navbar.Collapse id="responsive-navbar-nav">
            <nav className="me-auto d-flex justify-content-center align-items-center">
              <NavLink
                exact
                activeClassName="navbar_link_active"
                className="navbar_link nav-link active mx-3 fs-5 fw-bold my-auto p-0"
                to="/"
              >
                Home
              </NavLink>

              <NavLink
                activeClassName="navbar_link_active"
                className="navbar_link nav-link active mx-3 fs-5 fw-bold my-auto p-0"
                to="/team"
              >
                Team
              </NavLink>

              <HashLink
                className="navbar_link nav-link active mx-3 fs-5 fw-bold my-auto p-0"
                to="/#contact"
              >
                Contact Us
              </HashLink>

              <NavLink
                exact
                activeClassName="navbar_link_active"
                className="navbar_link nav-link active mx-3 fs-5 fw-bold my-auto p-0"
                to="/community"
              >
                Community
              </NavLink>
            </nav>
          </Navbar.Collapse>

          <Nav.Link
            onClick={handleShow}
            className=" navbar_link nav-link active mx-3 fs-5 fw-bold my-auto  p-0 "
          >
            <span className="d-none text-white d-md-inline  px-1">Menu</span>
            <CgMenuRight size="28" className="menu_icon" />
          </Nav.Link>
        </Container>
      </header>
      <CSSTransition
        in={show ? true : false}
        timeout={300}
        classNames="menu_transition"
        unmountOnExit
      >
        <div className="text-white menu">
          <Offcanvas.Header>
            <Offcanvas.Title className="zi4">
              <Link
                to="/"
                className="text-decoration-none mx-3 zi4"
                onClick={handleClose}
              >
                <Navbar.Brand className="zi4">
                  <img width="28" src={logo} alt="logo of zerko" />
                  {"  "}
                  <img width="89" src={zerkotype} alt="zerko text" />
                </Navbar.Brand>
              </Link>
            </Offcanvas.Title>
            <Button
              variant=""
              className="text-white btn-lg mx-3 p-0 zi4"
              onClick={handleClose}
            >
              <AiOutlineClose size={28} />
            </Button>
          </Offcanvas.Header>
          <Offcanvas.Body className="h-75">
            <Container className="d-flex flex-column align-items-center h-100 justify-content-end ">
              <div className="back zi3">
                <img src={star} className="menu_back_star_1" alt="star" />

                <img src={star} className="menu_back_star_2" alt="star" />

                <img src={star} className="menu_back_star_3" alt="star" />

                <img src={star} className="menu_back_star_4" alt="star" />

                <img src={star} className="menu_back_star_5" alt="star" />

                <img src={star} className="menu_back_star_6" alt="star" />

                <img src={star} className="menu_back_star_7" alt="star" />
              </div>

              <nav className="m-auto flex-column  justify-content-center align-items-center ">
                <NavLink
                  activeClassName="navbar_link_active"
                  className="navbar_link nav-link active mx-2 fs-1 fw-bold my-auto zi4"
                  to="/"
                  exact
                  onClick={handleClose}
                >
                  Home
                </NavLink>

                <NavLink
                  onClick={handleClose}
                  activeClassName="navbar_link_active"
                  className="navbar_link nav-link active mx-2 fs-1 fw-bold my-auto zi4"
                  to="/team"
                >
                  Team
                </NavLink>

                <NavHashLink
                  onClick={handleClose}
                  exact
                  className="navbar_link nav-link active mx-2 fs-1 fw-bold my-auto zi4"
                  to="/#contact"
                >
                  Contact Us
                </NavHashLink>

                <NavLink
                  onClick={handleClose}
                  exact
                  activeClassName="navbar_link_active"
                  className="navbar_link nav-link active mx-2 fs-1 fw-bold my-auto zi4"
                  to="/community"
                >
                  Community
                </NavLink>
              </nav>
              <nav className="d-flex flex-row m-auto justify-content-center align-items-center ">
                <a
                  href="https://www.twitter.com/zerkogg"
                  className=" mx-3 social_link zi4"
                  target="_blank"
                  rel="noreferrer"
                >
                  <FaTwitter size={22} />
                </a>
                <a
                  href="https://www.instagram.com/zerkogg"
                  target="_blank"
                  rel="noreferrer"
                  className="mx-3 social_link zi4"
                >
                  <FaInstagram size={22} className="" />
                </a>

                <a
                  href="https://www.youtube.com/zerkogg"
                  target="_blank"
                  rel="noreferrer"
                  className="mx-3 social_link zi4"
                >
                  <FaYoutube size={24} className="" />
                </a>

                <a
                  href="https://discord.gg/ekscSGmg27"
                  target="_blank"
                  rel="noreferrer"
                  className=" mx-3 social_link zi4"
                >
                  <FaDiscord size={24} className="" />
                </a>

                <a
                  href="https://www.tiktok.com/@zerkogg?"
                  target="_blank"
                  rel="noreferrer"
                  className=" mx-3 social_link zi4"
                >
                  <FaTiktok size={20} className="" />
                </a>
              </nav>
            </Container>
          </Offcanvas.Body>
        </div>
      </CSSTransition>
    </>
  );
}

export default MyNavbar;
